/**
 * Catégories du catalogue d'examens — miroir de backend/constants/medicalExamCategories.js.
 *
 * Pour étendre : ajouter une entrée ici + backend + page Head Doctor wrapper.
 */

export const MEDICAL_EXAM_CATEGORIES = {
  ANALYSIS: {
    id: 'ANALYSIS',
    label: 'Analyse médicale',
    labelPlural: 'Analyses médicales',
    pageTitle: 'Gestion des analyses médicales',
    pageSubtitle:
      'Référentiel institutionnel des analyses de laboratoire (code, libellé, prélèvement).',
    metadataFields: [
      {
        key: 'sample_type',
        label: 'Type de prélèvement',
        type: 'text',
        maxLength: 100,
        placeholder: 'Ex. Sang, Urines, Selles'
      }
    ]
  },
  RADIOGRAPHY: {
    id: 'RADIOGRAPHY',
    label: 'Radiographie',
    labelPlural: 'Radiographies',
    pageTitle: 'Gestion des radiographies',
    pageSubtitle:
      'Référentiel institutionnel des actes radiologiques (code, libellé, région anatomique).',
    metadataFields: [
      {
        key: 'body_region',
        label: 'Région anatomique',
        type: 'text',
        maxLength: 100,
        placeholder: 'Ex. Thorax, Bassin, Membre supérieur'
      },
      {
        key: 'projection',
        label: 'Incidence / projection',
        type: 'text',
        maxLength: 80,
        placeholder: 'Ex. Face, Profil, Oblique'
      }
    ]
  },
  ULTRASOUND: {
    id: 'ULTRASOUND',
    label: 'Échographie',
    labelPlural: 'Échographies',
    pageTitle: 'Gestion des échographies',
    pageSubtitle:
      'Référentiel institutionnel des actes échographiques (libellé, région anatomique, type d\'examen).',
    metadataFields: [
      {
        key: 'body_region',
        label: 'Région anatomique',
        type: 'text',
        maxLength: 100,
        placeholder: 'Ex. Abdomen, Pelvis, Thyroïde'
      },
      {
        key: 'exam_type',
        label: 'Type d\'examen',
        type: 'text',
        maxLength: 80,
        placeholder: 'Ex. Abdominale, Pelvienne, Obstétricale'
      }
    ]
  }
};

export const MEDICAL_COVERAGE_TYPES = {
  SMIE: {
    id: 'SMIE',
    label: 'PRISE EN CHARGE SMIE'
  },
  CMC: {
    id: 'CMC',
    label: 'PRISE EN CHARGE CMC'
  }
};

export const ANALYSIS_FAMILIES = {
  HEMATOLOGIE: { id: 'HEMATOLOGIE', label: 'Hématologie' },
  BIOCHIMIE_DU_SANG: { id: 'BIOCHIMIE_DU_SANG', label: 'Biochimie du sang' },
  PRELEVEMENT: { id: 'PRELEVEMENT', label: 'Prélèvement' },
  IMMUNOLOGIE: { id: 'IMMUNOLOGIE', label: 'Immunologie' },
  BIOCHIMIE_URINES: { id: 'BIOCHIMIE_URINES', label: 'Biochimie urines' }
};

/** @param {string} categoryId */
export function getMedicalExamCategoryConfig(categoryId) {
  return MEDICAL_EXAM_CATEGORIES[String(categoryId || '').toUpperCase()] || null;
}

/** Valeurs metadata par défaut pour une catégorie (formulaire vide). */
export function buildEmptyMetadata(categoryId) {
  const config = getMedicalExamCategoryConfig(categoryId);
  if (!config) return {};

  return config.metadataFields.reduce((acc, field) => {
    if (field.type === 'boolean') {
      acc[field.key] = Boolean(field.defaultValue);
    } else {
      acc[field.key] = '';
    }
    return acc;
  }, {});
}

/** Formulaire vide pour une catégorie donnée. */
export function buildEmptyExamForm(categoryId) {
  return {
    name: '',
    description: '',
    coverage_type: MEDICAL_COVERAGE_TYPES.SMIE.id,
    analysis_family: categoryId === MEDICAL_EXAM_CATEGORIES.ANALYSIS.id ? ANALYSIS_FAMILIES.HEMATOLOGIE.id : '',
    is_active: true,
    metadata: buildEmptyMetadata(categoryId)
  };
}
